export default {
  pages: {},
  wrongPages: {},
  pagination: {},
  cardPages: {},
  selectedOptions: {},
  preselectedOption: {},
  preEnteredValues: {},
  startTime: new Date(),
};
